export default "__VITE_ASSET__BfBnGu6P__"